import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { CommissionType } from "@/lib/commission-catalog.api";
import type { CommissionEditRequestStatusFilter } from "@/hooks/queries/useCommissionEditRequests";
import {
  ALL_TYPE_FILTER_VALUE,
  type CommissionEditQueueViewMode,
} from "../commissionEditQueue.constants";
import { CommissionEditQueueViewToggle } from "./CommissionEditQueueViewToggle";

interface CommissionEditQueueToolbarProps {
  search: string;
  statusFilter: CommissionEditRequestStatusFilter;
  typeFilter: string;
  viewMode: CommissionEditQueueViewMode;
  types: CommissionType[];
  onSearchChange: (value: string) => void;
  onStatusFilterChange: (value: CommissionEditRequestStatusFilter) => void;
  onTypeFilterChange: (value: string) => void;
  onViewModeChange: (mode: CommissionEditQueueViewMode) => void;
}

export function CommissionEditQueueToolbar({
  search,
  statusFilter,
  typeFilter,
  viewMode,
  types,
  onSearchChange,
  onStatusFilterChange,
  onTypeFilterChange,
  onViewModeChange,
}: CommissionEditQueueToolbarProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 border-y border-border py-3 xl:flex-row xl:items-center xl:justify-between">
      <div className="grid flex-1 gap-2 sm:grid-cols-[minmax(220px,320px)_180px_220px]">
        <div className="relative">
          <Search
            size={13}
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-subtle"
          />
          <Input
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Rechercher une demande..."
            className="pl-8"
          />
        </div>

        <Select
          value={statusFilter}
          onValueChange={(value) =>
            onStatusFilterChange(value as CommissionEditRequestStatusFilter)
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Statut" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tous les statuts</SelectItem>
            <SelectItem value="pending">En attente</SelectItem>
            <SelectItem value="approved">Approuvées</SelectItem>
            <SelectItem value="rejected">Refusées</SelectItem>
          </SelectContent>
        </Select>

        <Select value={typeFilter} onValueChange={onTypeFilterChange}>
          <SelectTrigger>
            <SelectValue placeholder="Type de commission" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL_TYPE_FILTER_VALUE}>Tous les types</SelectItem>
            {types.map((type) => (
              <SelectItem key={type.code} value={type.code}>
                {type.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <CommissionEditQueueViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
    </div>
  );
}
